export default __webpack_public_path__ + "static/entrepreneurship-icon-299059dec47acc82542ba26537585937.svg";